import styled from "@emotion/styled";
import {TextField} from "@mui/material";
import {breakpoints} from "assets/theme";

export const Input = styled(TextField)`
	text-align: left;
	width: 100%;
	background: rgba(255, 255, 255, 0.09);
	border-radius: 4px;

	&& .Mui-focused {
		color: ${({theme}) => theme.colorPalette.secondary};
	}

	&& label {
		&.Mui-disabled {
			opacity: 0.5;
		}

		color: #c2c2c2;
	}

	& .MuiInputBase-root,
	.MuiAutocomplete-inputRoot {
		color: ${({theme}) => theme.colorPalette.white};
		-webkit-text-fill-color: ${({theme}) => theme.colorPalette.white};

		&:after {
			border-color: ${({theme}) => theme.colorPalette.primary};
		}

		&.Mui-error:after {
			border-color: #a82727;
		}

		&.Mui-disabled input,
		&.Mui-disabled div {
			color: rgba(255, 255, 255, 0.6);
			-webkit-text-fill-color: rgba(255, 255, 255, 0.6);
		}
	}

	// input Adornment color
	&&& .MuiIconButton-root path {
		fill: rgba(255, 255, 255, 0.56);
	}

	& .MuiFormHelperText-root {
		color: #a3a3a3;
	}

	// select arrow color
	& .MuiSvgIcon-root {
		color: rgba(255, 255, 255, 0.56);
	}

	& .MuiFormHelperText-root.Mui-error {
		color: #a82727;
	}
`;

Input.defaultProps = {
	variant: "filled",
	SelectProps: {
		MenuProps: {
			PaperProps: {
				sx: {
					bgcolor: "#121212",
					color: "#ffffff",

					"& .MuiMenuItem-root.Mui-selected": {
						backgroundColor: "#FFFFFF14",
					},
					"& .MuiMenuItem-root:hover": {
						backgroundColor: "#FFFFFF14",
					},
					"& .MuiMenuItem-root.Mui-selected:hover": {
						backgroundColor: "#FFFFFF14",
					},
				},
			},
		},
	},
};

export const Select = styled(Input)`
	&& .MuiSelect-select.MuiInputBase-input {
		padding-right: 36px;
	}

	.MuiSelect-icon {
		top: auto;
		right: 12px;
	}
`;

Select.defaultProps = {
	select: true,
	variant: "filled",
};

export const SearchInput = styled(Input)`
	@media (min-width: ${breakpoints.medium}) {
		max-width: 310px;
	}
`;
